module.exports = __webpack_public_path__ + "static/img/potatoes.f67931a.svg";


//////////////////
// WEBPACK FOOTER
// ./static/website/images/potatoes.svg
// module id = 6pZN
// module chunks = 1